import React, { Component } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { api } from '../../api';

export class DeleteChapter extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
    };
  }

  deleteAction() {
    this.setState({ loading: true });
    const {
      match,
      obj,
      update,
      onHide,
      soft,
    } = this.props;

    const request = soft
      ? api.post(`/v1/books/${match.params.id}/chapters/${obj.id}/softdelete`)
      : api.delete(`/v1/books/${match.params.id}/chapters/${obj.id}`);

    request
      .then(() => {
        update();
        onHide();
      })
      .catch(() => {
        update();
      });
  }

  render() {
    const {
      obj,
      onHide,
      disabled,
      update,
      staticContext,
      soft,
      ...props
    } = this.props;

    const { loading } = this.state;

    return (
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {soft ? 'Soft Delete Episode:' : 'Delete Episode:'}
            <span>
              &quot;
              {obj.title}
              &quot;
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">
            {soft
              ? 'This will mark the active and live versions of this episode as deleted. Do you really want to soft delete the Episode?'
              : 'Do you really want to delete the Episode?'}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="reset"
            variant="secondary"
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            onClick={() => this.deleteAction()}
            disabled={disabled}
          >
            {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            )}
            {soft ? 'Soft Delete' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
